var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PictureDisplay',{attrs:{"image-list":_vm.images}}),_c('SiteFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }